(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1581],{

/***/ 58722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_WhatMakeUsDifferent; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(9846);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/Index.module.scss
var Index_module = __webpack_require__(81131);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/CardMakeDifferent.js







function CardMakeDifferent(_ref) {
  var title = _ref.title,
      description = _ref.description,
      src = _ref.src,
      alt = _ref.alt,
      rowReverse = _ref.rowReverse,
      listWithIcon = _ref.listWithIcon,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row justify-center ".concat(rowReverse && "flex-reverse" || ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      loading: "lazy",
      src: src,
      width: width || 540,
      height: height || 540,
      className: "h-auto w-full",
      wrapper: {
        className: "lg:col-6 flex items-center justify-center"
      },
      alt: alt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " justify-center lg:col-6 lg:flex lg:flex-col",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:pr-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          as: "h3",
          className: " mt-6 text-lg font-semibold text-bbc-brand-700 lg:mt-0 lg:text-bbc-30px",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "mt-4 inline-block rounded-full lg:mt-6 ".concat((Index_module_default()).line, " ")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:text-normal mt-4",
          children: Array.isArray(description) ? description.map(function (item, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-semibold",
                children: item.content
              }), item.listWithIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-2 mb-6",
                children: item.listWithIcon.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                    data: item
                  }, index);
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
            }, idx);
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [description, listWithIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-3",
              children: listWithIcon.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                  data: item
                }, index);
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
          })
        })]
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/WMUDSlider.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var PostSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 4194).then(__webpack_require__.bind(__webpack_require__, 82385));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82385)];
    },
    modules: ["../components/organisms/WhatMakeUsDifferent/WMUDSlider.js -> " + "components/organisms/PostSlider"]
  }
});

var WMUDSlider = function WMUDSlider(_ref) {
  var data = _ref.data;
  var swiper = {
    direction: "vertical",
    preloadImages: false,
    lazy: true,
    autoHeight: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    speed: 800,
    fadeEffect: {
      crossFade: true
    },
    virtualTranslate: true,
    effect: "fade",
    mousewheel: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletClass: "bbc-pagination-bullet block my-1",
      bulletActiveClass: "bbc-pagination-bullet-active h-10 w-2.5"
    },
    slidesPerView: "auto",
    spaceBetween: 0
  };

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container h-auto overflow-auto lg:h-[550px] lg:overflow-hidden",
    children: screen === "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " relative ",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        modules: [swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl, swiper_esm/* Autoplay */.pt, swiper_esm/* Mousewheel */.Gk, swiper_esm/* EffectFade */.xW]
      }, swiper), {}, {
        children: [Array.isArray(data) && data.length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: " flex text-left",
              style: {
                height: "550px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
                title: item.title,
                description: item.description,
                src: item.img_src,
                width: item.width,
                height: item.height,
                alt: item.img_alt,
                listWithIcon: item.listWithIcon
              })
            })
          }, index);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bbc-slide-pagination absolute right-0 z-10 -translate-y-1/2 pt-6",
          style: {
            top: "16rem"
          }
        })]
      }))
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider, {
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 50
        }
      },
      children: Array.isArray(data) && data.length > 0 && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-full ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
              title: item.title,
              description: item.description,
              src: item.img_src,
              alt: item.img_alt,
              width: item.width,
              height: item.height,
              rowReverse: true,
              listWithIcon: item.listWithIcon
            })
          })
        }, index);
      })
    })
  });
};

/* harmony default export */ var WhatMakeUsDifferent_WMUDSlider = (WMUDSlider);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/index.js


var _excluded = ["data", "title", "ebookImage"];

function WhatMakeUsDifferent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function WhatMakeUsDifferent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WhatMakeUsDifferent_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WhatMakeUsDifferent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var WhatMakeUsDifferent = function WhatMakeUsDifferent(_ref) {
  var data = _ref.data,
      title = _ref.title,
      ebookImage = _ref.ebookImage,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", WhatMakeUsDifferent_objectSpread(WhatMakeUsDifferent_objectSpread({}, props), {}, {
    className: props.className || "bg-wmud py-12 ",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "bbc-title mb-10 px-4 text-center lg:px-0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overflow-hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        classNamePrefix: "wmud-lazyload",
        placeholder: data.length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
            title: item.title,
            description: item.description,
            src: item.img_src,
            width: item.width,
            height: item.height,
            alt: item.img_alt,
            listWithIcon: item.listWithIcon
          }, index);
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent_WMUDSlider, {
          data: data,
          ebookImage: ebookImage
        })
      })
    })]
  }));
};

/* harmony default export */ var organisms_WhatMakeUsDifferent = (WhatMakeUsDifferent);

/***/ }),

/***/ 66059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_action_function_scrollToElement__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97974);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47447);
/* harmony import */ var components_organisms_FormDowload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73765);
/* harmony import */ var components_organisms_WhatMakeUsDifferent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58722);
/* harmony import */ var components_organisms_WhatMakeUsDifferent_WhatMakeUsDifferentV3__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97542);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var IncorporationCheckListTemplate = function IncorporationCheckListTemplate(_ref) {
  var dataJson = _ref.dataJson,
      widthBanner = _ref.widthBanner;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      minHeightBanner: " min-h-[607px]",
      breadcrumbs: dataJson.breadcrumbs,
      tag: dataJson.tag,
      title: dataJson.title,
      description: dataJson.description,
      titleProps: {
        className: "banner-default-title mb-4 lg:mb-10",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      bgColor: "bg-bbc-country",
      rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        wrapper: {
          className: "bbc-banner-image-country pb-10 ".concat(widthBanner ? widthBanner : "")
        },
        src: "/assets/images".concat(dataJson.banner_image),
        className: "h-full w-full",
        width: dataJson.banner_image_width || 630,
        height: dataJson.banner_image_height || 452,
        priority: true,
        alt: "banner-img"
      }),
      leftContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mb-6 text-center lg:mb-0 lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          href: "#".concat(dataJson.dataFormDowload.id),
          as: "a",
          className: "",
          onClick: function onClick(e) {
            (0,common_action_function_scrollToElement__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(e, false);
          },
          children: "Download now"
        })
      })
    }), dataJson.ebookImage ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_organisms_WhatMakeUsDifferent_WhatMakeUsDifferentV3__WEBPACK_IMPORTED_MODULE_5__/* .WhatMakeUsDifferentV3 */ .N, {
      title: dataJson.whatMakeUsDifferentTitle,
      data: dataJson.dataWhatMakeUsDifferent,
      ebookImage: dataJson.ebookImage,
      className: "lg:bbc-F7FAFD bg-bbc-brand-100 pt-10 pb-6 lg:py-[80px]"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_organisms_WhatMakeUsDifferent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      title: dataJson.whatMakeUsDifferentTitle,
      data: dataJson.dataWhatMakeUsDifferent,
      className: "lg:bbc-F7FAFD bg-bbc-brand-100 pt-10 pb-6 lg:py-[80px]"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
      className: "relative bg-bbc-terms-policy",
      id: dataJson.dataFormDowload.id,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "container relative z-10 py-10 lg:py-[100px]",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_organisms_FormDowload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          title: dataJson.dataFormDowload.title || "",
          description: dataJson.dataFormDowload.description || "",
          checkboxText: dataJson.dataFormDowload.form.checkboxText || "",
          apiLink: dataJson.dataFormDowload.form.apiLink || "",
          triggerName: dataJson.dataFormDowload.form.triggerName || "",
          contactFromId: dataJson.dataFormDowload.form.contactFromId || "",
          checkedId: dataJson.dataFormDowload.form.checkedId || "",
          unCheckId: dataJson.dataFormDowload.form.unCheckId || ""
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (IncorporationCheckListTemplate);

/***/ }),

/***/ 83270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/incorporation-checklist/index.js
var incorporation_checklist = __webpack_require__(66059);
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/offshore-ebook-download/data.json
var data_namespaceObject = JSON.parse('{"uri":"/guide-and-tool/offshore-ebook-download","title":"Handbook For Going Offshore","tag":"Free Ebook","description":"A comprehensive guide covering everything you need to know about starting, running, and managing your business in offshore jurisdictions.","banner_image":"/offshore/guide-and-tool/offshore-ebook/banner-offshore-ebook.png","banner_image_width":554,"banner_image_height":423,"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Guide & Tool","uri":"/guide-and-tool"},{"title":"Offshore Ebook","uri":"/guide-and-tool/offshore-ebook"}],"whatMakeUsDifferentTitle":"Here\'s a Preview of What You’ll Learn","ebookImage":{"src":"/assets/images/offshore/guide-and-tool/offshore-ebook/offshore-ebook-incorporation.png","width":540,"height":514},"dataWhatMakeUsDifferent":[{"title":"Incorporation","description":[{"listWithIcon":["Key features of offshore company","Top offshore countries for company incorporation","Types of offshore structures to consider","Procedure to form an offshore company, from picking names to fulfilling KYC and submitting application"]}],"img_src":"/assets/images/offshore/guide-and-tool/offshore-ebook/offshore-ebook-incorporation.png"},{"title":"Compliance","description":[{"listWithIcon":["Compliance obligations for U.S citizens","International compliance rules"]}],"img_src":"/assets/images/offshore/guide-and-tool/offshore-ebook/offshore-ebook-incorporation.png"},{"title":"Banking","description":[{"listWithIcon":["Best countries to open offshore bank account","Checklist of required documents for bank application","Virtual banks and Electronic Money Institutions (EMIs)","Tips to increase success rate for bank account opening"]}],"img_src":"/assets/images/offshore/guide-and-tool/offshore-ebook/offshore-ebook-incorporation.png"}],"dataFormDowload":{"id":"offshore-ebook","title":"Ready to learn more about doing business in offshore countries?","description":"Fill out the form to access your Handbook for Going Offshore.","form":{"triggerName":"Ebook - Offshore Company","apiLink":"api/portal/contact_form/profile_request","contactFromId":23,"checkboxText":"Get email updates from BBCIncorp about news, offers, and events related to doing business offshore. We\'re committed to your privacy and we will never sell, rent or spam your email. For more information, review our <a href=\'/offshore/privacy-policy\' class=\\"text-bbc-primary\\" target=\'_blank\'>Privacy Policy</a> and <a href=\'/offshore/terms-of-services\' class=\\"text-bbc-primary\\" target=\'_blank\'>Terms of Services.</a>","checkedId":21,"unCheckId":23}}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/offshore-ebook-download/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(incorporation_checklist/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      widthBanner: "lg:max-w-[410px] xl:max-w-[556px]"
    })
  });
}

/***/ }),

/***/ 5706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/guide-and-tool/offshore-ebook-download",
      function () {
        return __webpack_require__(83270);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line":"Index_line__t7vab"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,4868,4090,9738,7447,7720,2888,179], function() { return __webpack_exec__(5706); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);